import * as React from 'react';

import classnames from 'classnames';

import {colors} from '../../colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {ArrowsAscIcon} from '../../icon/svg/arrows-asc-icon';
// @ts-expect-error - imported from .js/.jsx file
import {ArrowsDescIcon} from '../../icon/svg/arrows-desc-icon';
// @ts-expect-error - imported from .js/.jsx file
import {FilterIcon} from '../../icon/svg/filter-icon';

import {TableRowCheckbox} from '../table-body/table-row-checkbox';
import type {HeaderGroup} from '../types';

import {TableHeaderCell} from './table-header-cell';

import styles from './table-header-row.module.css';

type Props = {
    isResizable: boolean;
    isCompact: boolean;
    isSticky: boolean;
    getToggleAllRowsSelectedProps: (...args: any) => any;
    headerGroup: HeaderGroup;
    tableHasActionMenus: boolean;
    tableHasExpandCell: boolean;
    shouldPreventSelectAll: boolean;
    isCheckboxSelectable: boolean;
    hasCellBorders: boolean;
    hasBottomBorder: boolean;
    hasTopBorder: boolean;
    hasLeftBorder: boolean;
    hasRightBorder: boolean;
    headerBackgroundColor?: 'offWhite' | 'offWhiteDk';
    extendToFitWidth?: boolean;
};

export function TableHeaderRow(props: Props) {
    const {isResizable, isCompact, headerGroup, tableHasActionMenus, tableHasExpandCell} = props;

    const styleNames = classnames({
        [styles['border--bottom']]: props.hasBottomBorder,
        [styles['border--top']]: props.hasTopBorder,
        [styles['border--left']]: props.hasLeftBorder,
        [styles['background--off-white']]: props.headerBackgroundColor === 'offWhite',
        [styles['background--off-white-dk']]: props.headerBackgroundColor === 'offWhiteDk',
        [styles.sticky]: props.isSticky,
    });

    const TR = isResizable ? 'div' : 'tr';
    const TH = isResizable ? 'div' : 'th';

    return (
        <TR {...headerGroup.getHeaderGroupProps()} className={styleNames}>
            {headerGroup.headers.map((column, index) => {
                const customHeaderTitle = column.canSort
                    ? `Sort by ${
                          column.Header && typeof column.Header === 'string'
                              ? column.Header
                              : column.id
                      } ${!column.isSorted || column.isSortedDesc ? 'ascending' : 'descending'}`
                    : undefined;

                const getHasCellBorders = () => {
                    if (!props.hasRightBorder && index === headerGroup.headers.length - 1) {
                        return false;
                    } else if (tableHasActionMenus && index === headerGroup.headers.length - 1) {
                        return false;
                    } else {
                        return props.hasCellBorders;
                    }
                };

                const sortIcon = getSortIcon(column);

                const resizerStyleName = classnames(styles.resizer, {
                    [styles.isResizing]: column.isResizing,

                    // We should not offer a resizer if the column is not resizable
                    [styles['resizer-width-0']]:
                        column.maxWidth && column.minWidth && column.maxWidth === column.minWidth,
                });

                return (
                    <TableHeaderCell
                        column={column}
                        isResizable={isResizable}
                        isCompact={isCompact}
                        key={column.id}
                        hasCellBorders={getHasCellBorders()}
                        hasDkCellBorder={props.headerBackgroundColor === 'offWhiteDk'}
                        customHeaderTitle={customHeaderTitle}
                    >
                        {index === 0 && props.isCheckboxSelectable ? (
                            <TableRowCheckbox
                                getToggleRowSelectedProps={props.getToggleAllRowsSelectedProps}
                                disabled={props.shouldPreventSelectAll}
                            />
                        ) : null}
                        <span className={styles.truncated}>{column.render('Header')}</span>
                        {column.canFilter ? (
                            <span className={styles['filter-icon']}>
                                <FilterIcon wrapWithDiv={false} size={13} fill={colors.greyLt} />
                            </span>
                        ) : null}
                        {sortIcon && (
                            <span className={styles['sort-icon']}>{getSortIcon(column)}</span>
                        )}
                        {column.canResize && column.getResizerProps ? (
                            // Add resize handle
                            <div {...column.getResizerProps()} className={resizerStyleName} />
                        ) : null}
                    </TableHeaderCell>
                );
            })}
            {props.extendToFitWidth ? (
                <td className={styles['extend-to-fit-placeholder-cell']} />
            ) : null}
            {tableHasExpandCell ? <TH className={styles['expand-spacer-cell']} /> : null}
            {tableHasActionMenus ? <TH className={styles['action-button-spacer-cell']} /> : null}
        </TR>
    );
}

// @ts-expect-error
function getSortIcon(column) {
    if (column.canSort && column.isSorted) {
        return column.isSortedDesc ? (
            <ArrowsDescIcon wrapWithDiv={false} size={15} fill={colors.blue} />
        ) : (
            <ArrowsAscIcon wrapWithDiv={false} size={15} fill={colors.blue} />
        );
    }

    return column.canSort ? '' : '';
}
